import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './WhyUs.module.scss';

const pillarKeys = ['dataControl', 'seamlessSync', 'businessMail', 'openFoundations'] as const;

export const WhyUs: React.FC = () => {
  const { t } = useTranslation('home');

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t('whyUs.heading')}</h2>
      <div className={styles.grid}>
        {pillarKeys.map((key) => (
          <div key={key} className={styles.card}>
            <h3 className={styles.title}>{t(`whyUs.pillars.${key}.title`)}</h3>
            <p className={styles.description}>{t(`whyUs.pillars.${key}.description`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
